import { markRaw } from 'vue'
import HierarchiesService from 'src/services/hierarchies'

export default {
  newHierarchy (payload) {
    const promise = HierarchiesService.newHierarchy(payload)

    return promise
  },
  fetcHierarchies () {
    this.status = 'loading'
    const promise = HierarchiesService.fetcHierarchies()

    promise.then(data => {
      this.hierarchies = markRaw(data)
      this.status = 'success'
    })

    return promise
  },
  deleteHierarchy (hierarchyId) {
    const promise = HierarchiesService.deleteHierarchy(hierarchyId)

    return promise
  }
}
